export default "__VITE_ASSET__29140059__"